@for (breadcrumb of breadcrumbs; track breadcrumb; let isLast = $last; let index = $index) {
  @if (!isLast) {
    <a [routerLink]="breadcrumb.url" [attr.data-cy]="'breadcrumb-level-' + index"
    (click)="changeContext(breadcrumb.url)">{{breadcrumb.label}}</a>
    <span class="iwp-icon-gen_nav_arrow_right separator"></span>
  }
  @if (isLast) {
    <span [attr.data-cy]="'breadcrumb-level-' + index">{{breadcrumb.label}}</span>
  }
}
